export default "__VITE_ASSET__BnqHJOFu__"